import { useQuery } from '@tanstack/vue-query';
import Axios from 'axios';

export default function useCartQuery() {
  return useQuery({
    queryKey: ['cart'],
    queryFn: () => Axios.get('/api/cart/'),
  });
}
